import { render, staticRenderFns } from "./AvatarVcDemo.vue?vue&type=template&id=a6c8b64c&scoped=true&"
import script from "./AvatarVcDemo.vue?vue&type=script&lang=js&"
export * from "./AvatarVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./AvatarVcDemo.vue?vue&type=style&index=0&id=a6c8b64c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c8b64c",
  null
  
)

export default component.exports